import {useJobContext} from 'contexts/JobContext';
import {useAppContext} from 'contexts/ApplicationContext';
import {PartialJob} from 'shared/types/PartialJob';
import {useAppSelector} from 'store/customer';
import {selectJobDetails} from 'components/customer/Confirmation/store/confirmationSlice';

export const useCurrentDispatchMethod = () => {
    const {userProfile} = useAppContext();
    const {job} = useJobContext() as PartialJob;
    const jobDetails = useAppSelector(selectJobDetails);

    const captureDeliveryInfo =
        userProfile &&
        userProfile.jobConfirmationEnabled &&
        !userProfile.capturePickupFreightAtJobCreation;

    if (captureDeliveryInfo && jobDetails) {
        return jobDetails.dispatch;
    }

    return job?.dispatchMethod;
};
